export default __webpack_public_path__ + "static/media/account.152e4568.png";